import AtlasCopcoLogo from '../assets/atlascopco.png';
import EdwardsLogo from '../assets/edwards.png';
import LeyboldLogo from '../assets/leybold.png';
import ItekakoLogo from '../assets/itekako.png';

import { company } from './brand';

export const getLogo = () => {
  switch (company) {
    case 'atlascopco':
      return AtlasCopcoLogo;
    case 'edwards':
      return EdwardsLogo;
    case 'leybold':
      return LeyboldLogo;
    case 'itekako':
      return ItekakoLogo;
    default:
      return;
  }
}



// WEBPACK FOOTER //
// ./src/utils/logo.js